export type AnalyticsEnvironment = "development" | "staging" | "production";

export function resolveEnvironment(
  appEnv: string | undefined
): AnalyticsEnvironment {
  if (appEnv === "production") return "production";
  if (appEnv === "staging") return "staging";
  return "development";
}

export function isPostHogEnabled(flag: string | undefined): boolean {
  return flag === "true";
}

// PostHog project tokens share the same `phc_*` prefix across projects, so we
// cannot infer the target project from the token itself — map by environment.
export function resolveProjectName(
  token: string | undefined,
  environment: AnalyticsEnvironment
): string {
  if (!token) return "unknown";
  return environment === "production" ? "skrift-prod" : "skrift-nonprod";
}
